"use client";

import { c as _c } from "react/compiler-runtime";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Dialog, DialogContent, DialogTitle } from "@saridana-core/react-ui-kit";
import { useBoolean } from "@shared/hooks";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";
export const PopUp = () => {
  const $ = _c(20);
  const {
    value: isOpen,
    on: onOpen,
    off: onClose
  } = useBoolean(false);
  const config = useClientConfig();
  const popUpData = config?.layoutSettings?.attributes.features?.popUp;
  let t0;
  if ($[0] !== onOpen || $[1] !== popUpData) {
    t0 = () => {
      if (!popUpData) {
        return;
      }
      const timeout = setTimeout(() => onOpen(), (popUpData?.secondsToShow || 5) * 1000);
      return () => clearTimeout(timeout);
    };
    $[0] = onOpen;
    $[1] = popUpData;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  if (!popUpData) {
    return null;
  }
  const {
    imageDesktop,
    imageMobile,
    link
  } = popUpData;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogTitle />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== imageMobile || $[6] !== link || $[7] !== onClose) {
    t3 = imageMobile ? <Link className="sm:hidden" href={link} onClick={onClose}><Image priority={true} src={imageMobile?.data?.attributes?.url ?? ""} alt={imageMobile?.data?.attributes?.alternativeText || "mobile_popup_call_to_action_image"} width={300} height={400} style={{
        display: "block",
        objectFit: "cover"
      }} /></Link> : null;
    $[5] = imageMobile;
    $[6] = link;
    $[7] = onClose;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== imageDesktop || $[10] !== link || $[11] !== onClose) {
    t4 = imageDesktop ? <Link className="hidden sm:block" href={link} onClick={onClose}><Image priority={true} src={imageDesktop?.data?.attributes?.url ?? ""} alt={imageDesktop?.data?.attributes?.alternativeText || "desktop_popup_call_to_action_image"} width={600} height={400} style={{
        display: "block",
        objectFit: "cover"
      }} /></Link> : null;
    $[9] = imageDesktop;
    $[10] = link;
    $[11] = onClose;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <DialogContent>{t2}<div className="mt-4">{t3}{t4}</div></DialogContent>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isOpen || $[17] !== onClose || $[18] !== t5) {
    t6 = <Dialog open={isOpen} defaultOpen={isOpen} onOpenChange={onClose} modal={true}>{t5}</Dialog>;
    $[16] = isOpen;
    $[17] = onClose;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};